import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const nav = useNavigate();
  return (
    <div
      data-testid="not-found"
      className="rounded-2xl border border-border/60 bg-card/70 p-6"
    >
      <div data-testid="not-found-title" className="text-2xl font-semibold">
        Page not found
      </div>
      <div data-testid="not-found-subtitle" className="mt-2 text-sm text-muted-foreground">
        The page you’re looking for doesn’t exist.
      </div>
      <Button
        data-testid="not-found-home"
        className="mt-4 rounded-full bg-violet-500 text-white hover:bg-violet-400"
        onClick={() => nav("/")}
      >
        Go home
      </Button>
    </div>
  );
}
